/* eslint-disable max-len */
// Dependencies
import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import ReactMarkdown from 'react-markdown'


import Helpers from '../Helpers.js'
import {storePayload} from '../actions/storePayload'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesTaskView from '../styles/TaskView.module.css'
// import stylesTaskQueue from '../styles/TaskQueue.module.css'
import stylesModuleLogList from '../styles/ModuleLogList.module.css'
import stylesProcessOutput from '../styles/ProcessOutput.module.css'

// Components
import {Table, TableEntry} from '@lazarusai/forms-ui-components'

function TaskView({
  task,
  taskFiles = {},
  ...props
}) {
  const [fileRows, setFileRows] = useState([])

  useEffect(() => {
    if (taskFiles) {
      setFileRows(Object.keys(taskFiles)
          .map((fileKey, fIndex) => {
            const fileDict = taskFiles?.[fileKey]
            const fileName = fileDict?.name || fileKey
            const fileUrl = fileDict?.url
            const fileType = fileDict?.type
            const fileSize = fileDict?.file?.size || ''
            return (
              <TableEntry
                key={`${fIndex}-file-row`}
                content={[
                  <a
                    key={`${fIndex}-url`}
                    target='_blank'
                    rel='noopener noreferrer'
                    href={fileUrl}
                  >
                    {fileName}
                  </a>,
                  Helpers.fileSizeFormat(fileSize),
                  fileType,
                ]}
              />
            )
          }))
    }
  }, [taskFiles])

  return (<div
    className={stylesProcessOutput['detail-output']}
  >
    <div
      className={stylesTaskView['task-view-info-row']}
    >
      <div className={stylesTaskView['task-view-section-title']}>
        TIME
      </div>
      <div
        className={stylesTaskView['task-view-section-value']}
        style={{paddingRight: '24px'}}
      >
        {task?.last_update ? `${Helpers.timeStampToDate(task?.last_update)} ${Helpers.timeStampToTime(task?.last_update)}` : ''}
      </div>
      {task?.task_id &&
        <>
          <div className={stylesTaskView['task-view-section-title']}>
            ID
          </div>
          <div
            className={stylesTaskView['task-view-section-value']}
            style={{paddingRight: '24px'}}
          >
            {task?.task_id}
          </div>
        </>
      }
      <div className={stylesTaskView['task-view-section-title']}>
        STATUS
      </div>
      <div
        className={`${stylesTaskView['task-view-section-value']} ${stylesTaskView['capitalize']}`}
      >
        {task?.status || ''}
      </div>
    </div>
    <div className={stylesTaskView['task-view-section-title']}>
      PROMPT
    </div>
    <div
      className={stylesTaskView['task-view-section-value']}
    >
      {task?.prompt || ''}
    </div>
    <div className={stylesTaskView['task-view-section-spacer']} />
    {task?.status === 'finished' &&
      <>
        <div className={stylesTaskView['task-view-section-spacer']} />
        <div className={stylesTaskView['task-view-section-title']}>
          CONCLUSION
        </div>
        <div
          className={stylesTaskView['task-view-section-value']}
        >
          <ReactMarkdown>{task.logs[Object.keys(task.logs)[Object.keys(task.logs).length - 1]]?.content}</ReactMarkdown>
        </div>
      </>
    }
    <div className={stylesTaskView['task-view-section-spacer']} />
    <div className={stylesTaskView['task-view-section-spacer']}></div><div className={stylesTaskView['task-view-section-title']}>
      FILES
    </div>
    <div
      className={stylesTaskView['task-view-section-secondary-value']}
    >
      All files used in this task
    </div>
    <Table
      showCount={false}
      columnTitles={[
        <span
          key={'header-name'}
        >
          Name
        </span>,
        <span
          key={'header-size'}
        >
          Size
        </span>,
        <span
          key={'header-type'}
        >
          Type
        </span>,
      ]}
      theme={props.theme}
      className={`${stylesModuleLogList['mll-table']} ${stylesModuleLogList['mll-table-details']}`}
      entries={props.areFilesLoading ?
        [<TableEntry
          key={`files-loading`}
          content={[
            'Files Loading...',
            '',
            '',
          ]}
        />]:
        fileRows}
    />
  </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  currentTasks: state.userReducer.currentTasks,
  taskId: state.userReducer.taskId,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(TaskView)
